/* eslint-disable */
class StepBase {
  constructor(scene) {
    this.scene = scene;
    this.cameraPosition;
    this.cameraTarget;
    this.cameraRotationSpeed;

    this.meshList = {};

    this.root = BABYLON.MeshBuilder.CreateGround(
      "scene_root",
      { width: 0.01, height: 0.01 },
      this.scene
    );

    this.root.visibility = 0;
  }

  update() {}

  getCameraTarget() {
    return this.cameraTarget;
  }

  getCameraPosition() {
    return this.cameraPosition;
  }

  getCameraRotationSpeed() {
    return this.cameraRotationSpeed;
  }

  getRoot() {
    return this.root;
  }

  getMeshList() {
    return this.meshList;
  }
}
export default StepBase;
